// Same as TriState in Visual Basic
export enum TriState {
    UseDefault = -2, // 0xFFFFFFFE
    True = -1, // 0xFFFFFFFF
    False = 0
}

export enum UserRole {
    None = 0,
    Admin = 1,
    ExecutiveAdmin = 2,
    ContractorAdmin = 3,
    ContractorManager = 4
}

export enum LookupGroup {
    All = 0,
    LookupOne = 1,
    LookupTwo = 2
}

export enum BookingActionDirection {
    None = 0,
    Arriving = 1,
    Leaving = 2
}

export enum BookingActionResult  {
    None = 0,
    SuccessfulScan = 1,
    UserFailure = 2,
    CodeFailure = 3,
    UserProblem = 4,
    MissedScan = 5
}

export enum RedFlagMessageType {
    None = 0,
    IndeterminableRest = 1,
    InsufficientRest = 2
}

export enum ContractorUserRole {
    Admin = 3,
    Manager = 4
}

export enum ScanTiming {
    None = 0,
    WithinRange = 1,
    OutsideTimeRange = 2
}

export enum ScanMedium {
    None = 0,
    QrCode = 1,
    Nfc = 2
}

